;(function(){

	var $root = $('.js-bowling');
	var $next = $root.find('.js-bowling__next');
	var $prev = $root.find('.js-bowling__prev');
	var $select = $root.find('select.js-bowling__select');

	var page = 1;

	if (!$root.length) {
		return;
	}

	// trigger remodal
	$('[data-remodal-id*="modal"]').remodal();

	// track Facebook videos
	var videos = [];
	window.fbAsyncInit = function() {
		FB.Event.subscribe('xfbml.ready', function(msg) {
			if (msg.type === 'video') {
				videos.push(msg.instance);
			}
		});
	};

	// pause on close
	$(document).on('closed', '.remodal', function() {
		// Facebook
		$.each(videos, function(index, value){
			value.pause();
		});

		// YouTube
		$('#youtube-video')[0].contentWindow.postMessage(JSON.stringify({
			event: 'command',
			func: 'stopVideo',
			args: ''
		}), '*');
	});

	// pagination

	var pages = [];
	$root.find('.js-bowling__page').each(function() {
		pages.push($(this));
	});

	var changePage = function(newPage) {
		if (newPage < 1 || newPage > pages.length) {
			return;
		}

		$.each(pages, function(i, $page) {
			$page.toggleClass('is-hidden', i !== (newPage - 1));
		});
		$prev.parent().toggleClass('jump--disabled', newPage === 1);
		$next.parent().toggleClass('jump--disabled', newPage === pages.length);

		page = newPage;
		$select.val(newPage);
		$select.siblings('span').text(newPage);
	};

	$prev.on('click', function(e) {
		e.preventDefault();

		changePage(page - 1);
	});

	$next.on('click', function(e) {
		e.preventDefault();

		changePage(page + 1);
	});

	$select.on('change', function(e) {
		e.preventDefault();

		changePage(window.parseInt(this.value, 10));
	});

}());
